import axios from "axios";
import swal from "sweetalert2";

import { useState } from "react";
import { accessTokenKey, baseUrl, contact } from "../../utils/config";

function Contact () {

    const [submitting, setSubmitting] = useState(false);

    async function sendMessage() {
        const form = document.getElementById("form-contact");
        setSubmitting(true);

        try {
            const formData = new FormData(form);

            const response = await axios.post(
                baseUrl + "/api/send-message",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Contact Us", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSubmitting(false);
        }
    }

    const styles = {
        icon: {
            width: "45px",
            height: "45px"
        },
        message: {
            height: "200px"
        }
    };

    return (
        <>
            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Contact For Any Query</h1>
                    <div className="row g-4">
                        <div className="col-12">
                            <div className="row gy-4">
                                <div className="col-md-4 wow fadeIn" data-wow-delay="0.1s">
                                    <div className="d-flex align-items-center bg-light rounded p-4">
                                        <div className="bg-white border rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3" style={ styles.icon }>
                                            <i className="fa fa-map-marker-alt text-primary"></i>
                                        </div>
                                        <span>{ contact.address }</span>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeIn" data-wow-delay="0.3s">
                                    <div className="d-flex align-items-center bg-light rounded p-4">
                                        <div className="bg-white border rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3" style={ styles.icon }>
                                            <i className="fa fa-envelope-open text-primary"></i>
                                        </div>
                                        <span>{ contact.email }</span>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeIn" data-wow-delay="0.5s">
                                    <div className="d-flex align-items-center bg-light rounded p-4">
                                        <div className="bg-white border rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3" style={ styles.icon }>
                                            <i className="fa fa-phone-alt text-primary"></i>
                                        </div>
                                        <span>{ contact.phone }</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <iframe className="position-relative rounded w-100 h-100"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d435521.9536748705!2d74.00473508437405!3d31.482517988406073!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190483e58107d9%3A0xc23abe6ccc7e2462!2sLahore%2C%20Pakistan!5e0!3m2!1sen!2s!4v1745222501919!5m2!1sen!2s"
                                width="600" height="450"
                                aria-hidden="false" frameBorder="0"
                                allowFullScreen="" loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                tabIndex="0"></iframe>
                        </div>
                        <div className="col-md-6">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">
                                <p className="mb-4">Have questions, feedback, or want to collaborate? We’d love to hear from you. Reach out anytime via email, WhatsApp, or social media — we’re just a message away !</p>
                                <form onSubmit={ function (event) {
                                    event.preventDefault();
                                    sendMessage();
                                } } id="form-contact">
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input type="text" className="form-control" name="name" placeholder="Your Name" />
                                                <label>Your Name</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-floating">
                                                <input type="email" className="form-control" name="email" placeholder="Your Email" />
                                                <label>Your Email</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-floating">
                                                <input type="text" className="form-control" name="subject" placeholder="Subject" />
                                                <label>Subject</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-floating">
                                                <textarea className="form-control" placeholder="Leave a message here" name="message"
                                                    style={ styles.message }></textarea>
                                                <label>Message</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <button className="btn btn-primary w-100 py-3" type="submit"
                                                disabled={ submitting }>Send Message</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;